import Axios from "axios";

const httpGet = (url, data) => {
  return httpExec("GET", url, data);
};

const httpPut = (url, data) => {
  return httpExec("PUT", url, data);
};

const httpPost = (url, data) => {
  return httpExec("POST", url, data);
};

const httpDelete = (url, data) => {
  return httpExec("DELETE", url, data);
};

const httpExec = (method, url, data) => {
  console.log('httpExec',method,url,data);
  return new Promise((resolve, reject) => {
    Axios({
      method: method,
      url: url,
      data: data,
      withCredentials: true,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-Riot-Token": "RGAPI-c937b5fd-d6d1-4280-9350-1905c7e25ecd"
      },
    })
      .then((response) => {
         setTimeout(function() {
          resolve(response);
         }, 1000);
      })
      .catch((error) => {
        if (error.message.includes("401")) {
            // 세션 만료 시 로직 
            //alert("로그인이 만료되었습니다. 다시 로그인해주세요");
            //reactLocalStorage.remove("adminUser");
            //global.location.href = "/";
        }
        reject(error);
      });
  });
};

export {
  httpExec,
  httpGet,
  httpPut,
  httpPost,
  httpDelete,
};
